import React, { useState, useEffect } from "react";
import Card from "components/card";
import ServiceTable from "./components/ServiceTable";
import AddServiceModal from "./components/AddServiceModal";
import Pagination from "components/pagination";
import { useServices } from "./ServicesContext";

const PAGE_SIZE = 10;

const ServicesManagement = () => {
  const { services, addService, deleteService, toggleServiceStatus } = useServices();

  const [showAddServiceModal, setShowAddServiceModal] = useState(false);
  const [newService, setNewService] = useState({ name: "", status: "active", banner_img: "" });
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(1);
  }, [services.length]);

  const totalPages = Math.max(1, Math.ceil(services.length / PAGE_SIZE));
  const paginatedServices = services.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

  const handleAddServiceClick = () => {
    setNewService({ name: "", status: "active", banner_img: "" });
    setShowAddServiceModal(true);
  };

  const handleSaveService = async () => {
    const result = await addService(newService);
    if (result !== null) setShowAddServiceModal(false);
  };

  return (
    <div className="w-full">
      <div className="mb-8">
        {/* <p className="text-gray-600 dark:text-gray-400 mt-2">
          Manage laundry services, toggle active/inactive status, and add products to each service
        </p> */}
      </div>

      <Card extra={"w-full h-full sm:overflow-auto px-4 py-6"}>
        <ServiceTable
          services={paginatedServices}
          rowOffset={(page - 1) * PAGE_SIZE}
          onAddServiceClick={handleAddServiceClick}
          onToggleStatus={toggleServiceStatus}
          onDelete={(service) => deleteService(service.id)}
        />
        <Pagination
          currentPage={page}
          totalPages={totalPages}
          totalItems={services.length}
          pageSize={PAGE_SIZE}
          onPageChange={setPage}
          itemName="services"
        />
      </Card>

      {showAddServiceModal && (
        <AddServiceModal
          newService={newService}
          setNewService={setNewService}
          onCancel={() => setShowAddServiceModal(false)}
          onSave={handleSaveService}
        />
      )}
    </div>
  );
};

export default ServicesManagement;